import staticStore from '@aytm/app/insights/dashboard/stores/static.store'

type Action<T> = {
  type: string
  payload: T
  error?: boolean
}

export function ReadonlyViewMiddleware<T>(_api: unknown) {
  return (next: (action: Action<T>) => void) => (action: Action<T>) => {
    if (staticStore.isSharedView && (action.type.endsWith('updateBlock') || action.type.endsWith('updateFilters'))) {
      // TODO: confirm correctness and remove
      // eslint-disable-next-line no-console
      // console.log('SKIPPING:', action)
      next(action) // "same same but different"
      return
    }
    // console.log(action)
    next(action)
  }
}
